var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{class:[
    'select pa-0',
    _vm.isSelectOpen ? 'select--open' : 'select--closed',
    _vm.item.isEditable ? 'select--editable' : '',
    _vm.invalid ? 'error' : ''
  ],attrs:{"disabled":_vm.disabled,"items":_vm.options,"label":_vm.placeholder,"menu-props":{ bottom: true, offsetY: true },"hide-details":"auto","item-text":"name","item-value":"value","solo":""},on:{"blur":function($event){_vm.isSelectOpen = false},"change":_vm.handleOptionChange,"focus":function($event){_vm.isSelectOpen = true}},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}})}
var staticRenderFns = []

export { render, staticRenderFns }